import React, { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
export function ScrollToHash() {
  const location = useLocation();
  const {
    pathname,
    hash,
    key
  } = location;
  useEffect(() => {
    if (!hash) {
      window.scrollTo({
        top: 0,
        behavior: 'instant' as ScrollBehavior
      });
      return;
    }
    const id = hash.replace('#', '');
    const t = setTimeout(() => {
      const el = document.getElementById(id);
      if (el) {
        el.scrollIntoView({
          behavior: 'smooth',
          block: 'start'
        });
      }
    }, 50);
    return () => clearTimeout(t);
    // `key` changes on every navigation so clicking the same hash twice still re-runs.
  }, [pathname, hash, key]);
  return null;
}